import { mapGetters } from 'vuex';
import { adapi } from '~';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';

export default {
  components: {
    'box-widget': BoxWidget,
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    ...mapGetters('campaign', {
      campaign: 'currentCampaign',
    }),
    options() {
      return [
        { value: null, text: this.$t('terms.special-ad-category.NONE') },
        { value: 'HOUSING', text: this.$t('terms.special-ad-category.HOUSING') },
        { value: 'CREDIT', text: this.$t('terms.special-ad-category.CREDIT') },
        { value: 'EMPLOYMENT', text: this.$t('terms.special-ad-category.EMPLOYMENT') },
      ];
    },
  },
  methods: {
    onChange(category) {
      adapi.post(`campaigns/${this.campaign.code}/set-special-ad-category`, null, { category })
        .then(() => this.$toast.success({ message: this.$t('pos.campaign.special-ad-category-updated') }))
        .catch(e => this.$toast.error({ message: e.toString() }));
    },
  },
  watch: {
    campaign: {
      deep: true,
      immediate: true,
      handler: function watchCampaign(campaign) {
        this.selected = campaign ? campaign.special_ad_category : null;
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/special-ad-category/SpecialAdCategory.js